module.exports = __webpack_public_path__ + "img/pdf.afd8f140.png";